import { supabase } from './supabase'

export async function canManageScreening(userId: string, screeningId: number): Promise<boolean> {
  const { data: rows } = await supabase
    .from('screenings')
    .select('id, movie_id, movies(id, organizer_id, organizers(id, owner_id))')
    .eq('id', screeningId)
    .limit(1)
  const row = (rows && rows[0]) as any
  const organizerId: number | null = row?.movies?.organizer_id ?? null
  const ownerId: string | null = row?.movies?.organizers?.owner_id ?? null
  if (!organizerId) return false
  if (ownerId && ownerId === userId) return true
  const { data: editor } = await supabase
    .from('organizer_editors')
    .select('user_id')
    .eq('organizer_id', organizerId)
    .eq('user_id', userId)
    .limit(1)
  if (Array.isArray(editor) && editor.length > 0) return true
  const { data: validator } = await supabase
    .from('screening_validators')
    .select('user_id, active')
    .eq('screening_id', screeningId)
    .eq('user_id', userId)
    .eq('active', true)
    .limit(1)
  return Array.isArray(validator) && validator.length > 0
}

export async function canManageBooking(userId: string, bookingId: number): Promise<boolean> {
  const { data: row } = await supabase
    .from('bookings')
    .select('screening_id')
    .eq('id', bookingId)
    .maybeSingle()
  const screeningId = (row as { screening_id: number } | null)?.screening_id
  if (!screeningId) return false
  return canManageScreening(userId, screeningId)
}
